export const
	ADMIN_RESET = 'admin_reset',
	ADMINS_RESET = 'admins_reset',
    ADMINS_PENDING = 'admins_pending',
	ADMIN_FOCUS = 'admin_focus',
    ADMIN_FAILED = 'admin_failed',
    ADMIN_CONFLICT = 'admin_conflict',
    ADMINS_FAILED = 'admins_failed',
    ADMIN_DOWNLOADED = 'admin_downloaded',
    ADMINS_DOWNLOADED = 'admins_downloaded',
    ADMIN_POSTING = 'admin_posting',
    ADMIN_EDITING = 'admin_editing',
    ADMIN_DELETING = 'admin_deleting';



// WEBPACK FOOTER //
// src/store/admins/types.js